<div *ngIf="isPageReady" class="flex flex-col gap-4 p-1">
  <!-- QZ error / install hint -->
  <div *ngIf="errorMessage" class="np-card flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle"></i>
      <span class="font-semibold">{{ errorMessage }}</span>
    </div>
    <div *ngIf="showInstallHint" class="text-sm opacity-80">
      QZ Tray must be installed and running on this device for barcode printing to work.
    </div>
    <button type="button" class="np-btn np-btn-secondary np-btn-block" (click)="detectPrinters()">
      <i class="pi pi-refresh"></i>
      <span>Retry</span>
    </button>
  </div>

  <!-- Picker -->
  <div *ngIf="!errorMessage" class="flex flex-col gap-3">
    <label class="text-sm font-semibold" for="barcodePrinter">Barcode Printer (ZPL only)</label>
    <p-dropdown
      inputId="barcodePrinter"
      [(ngModel)]="barcodePrinter"
      [options]="clientPrinters"
      (onChange)="save()"
      placeholder="Select a printer"
      styleClass="w-full"
    ></p-dropdown>
  </div>

  <!-- Test -->
  <button
    type="button"
    class="np-btn np-btn-primary np-btn-block"
    [disabled]="!barcodePrinter"
    (click)="testBarcode()"
    title="Send a sample ZPL label to the selected printer"
  >
    <i class="pi pi-print"></i>
    <span>Test Barcode Printer</span>
  </button>

  <!-- Close -->
  <button type="button" class="np-btn np-btn-secondary np-btn-block" (click)="close()">
    <span>Close</span>
  </button>
</div>
